// extracted by mini-css-extract-plugin
module.exports = {"container":"NoticeWithIcon_container__w6a8x"};